<template>
    <!--顶部导航-->
    <div class="header" style="z-index: 90;">
        <div class="menuBtn" @click="handleMenu">
            <img src="@/asstes/home/menu.png">
        </div>
        <div class="header_logo_pc">
            <img src="@/asstes/home/logo_app.png">
        </div>
<!--        <div class="header_logo_app">-->
<!--            <img src="@/asstes/home/logo_app.png">-->
<!--        </div>-->

        <div class="header_menu_pc">
            <!--
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                     text-color="#353856" active-text-color="#07CFA2">
                <el-menu-item index="index">首 页</el-menu-item>
                <el-menu-item index="solution">解决方案</el-menu-item>
                <el-menu-item index="customerCase">客户案列</el-menu-item>
                <el-menu-item index="aboutUs">关于我们</el-menu-item>
            </el-menu>
            -->
            <div class="menu_item" v-for="(item, index) in menuList" :key="index">
                <div :class="{'active': item.id == accountActive}"
                     @click="handleSelect(item.path, item.id)">{{ item.name }}</div>
            </div>
<!--            <div class="header_menu_pc_try" style="z-index: 90;">产品试用</div>-->
        </div>
        <div class="header_menu_app">
            <el-drawer :visible.sync="drawer" :direction="direction">
                <div class="menu_item" v-for="(item, index) in menuList" :key="index">
                    <div :class="{'active': item.id == accountActive}"
                         @click="accountActive = item.id | handleSelect(item.path)">{{ item.name }}</div>
                </div>
<!--                <div class="header_menu_try" style="z-index: 90;">产品试用</div>-->
            </el-drawer>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                accountActive: 1,
                menuList: [
                    {
                        id: 1,
                        name: '首 页',
                        path: '/'
                    },
                    {
                        id: 2,
                        name: '解决方案',
                        path: '/solution'
                    },
                    {
                        id: 3,
                        name: '客户案例',
                        path: '/customerCase'
                    },
                    {
                        id: 4,
                        name: '关于我们',
                        path: '/aboutUs'
                    },
                ],
                // screenWidth: '',
                // 菜单列表
                menuShow: true,
                // 菜单按钮
                menuBtnShow: true,
                drawer: false,
                direction: 'rtl',
            };
        },
        watch: {
            '$route':{
                handler(to, from){
                    // this.tempList()
                    // console.log(to.path)
                  if( to.path == '/' ) this.accountActive = 1;
                  if( to.path == '/solution' ) this.accountActive = 2;
                  if( to.path == '/customerCase' ) this.accountActive = 3;
                  if( to.path == '/aboutUs' ) this.accountActive = 4;

                },
                deep: true
            },
            // screenWidth(val){
            //     // console.log(val)
            //     if( val <= 580 ){
            //         this.menuShow = false;
            //         this.menuBtnShow = true;
            //     }else {
            //         this.menuShow = true;
            //         this.menuBtnShow = false;
            //     }
            // }
        },
        mounted() {
            this.tempList();
            // window.onresize = () => {
            //     return (() => {
            //         this.screenWidth = document.body.clientWidth;
            //         // this.$store.commit('setScreenWidth', this.screenWidth)
            //     })();
            // };

        },
        methods: {

            handleSelect(path, val) {
                let that = this;
                that.accountActive = val
                if(path != that.$route.path){
                    that.$router.push({ path: path });
                    that.drawer = false;
                }
            },
            handleMenu(){
                let that = this;
                that.drawer = true;
            },
            tempList(){
                let that = this;
                let path = that.$route.path;
                that.menuList.forEach(li => {
                    if( path === li.path ){
                        that.accountActive = li.id
                    }
                })
            }
        },
    }
</script>

<style lang="less" scoped>
    @media only screen and (max-width: 750px){
        .header{
            display: flex;
            flex-wrap: wrap;
            padding: 0;
            font-size: 14px;
            color: #353856;
            .menuBtn{
                z-index: 400;
                width: 100%;
                display: flex;
                justify-content: flex-end;
                padding: 56px;
                box-sizing: border-box;
            }

            .header_logo_pc{
                display: none;
            }
            .header_logo_app{
                z-index: 400;
                width: 100%;
                display: flex;
                justify-content: center;
                padding-top: 224px;
                box-sizing: border-box;
                img{
                    padding-top: 100px;
                    width: 36%;
                }
            }

            .header_menu_app{

                /deep/ .el-drawer{
                    font-size: 50.4px;
                    color: #353856;
                    width: 62% !important;
                }

                .menu_item{
                    padding-left: 168px;
                    box-sizing: border-box;
                    div{
                        padding-bottom: 224px;
                        box-sizing: border-box;
                    }
                    .active{
                        color: #0BBAB4;
                    }
                }
                .header_menu_try{
                    padding-left: 168px;
                    padding-bottom: 224px;
                    box-sizing: border-box;
                }
            }
            .header_menu_pc{
                display: none;
            }

        }
    }
    @media only screen and (min-width: 750px){
        .header{
            color: #353856;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: nowrap;
            width: 100%;
            padding: 31px 72px 0 72px;
            box-sizing: border-box;
            font-size: 12px;
            .header_logo_pc{
                z-index: 90;
                width: auto;
                img{
                    width: 116%;
                }
            }
            .header_logo_app{
                display: none;
            }

            .menuBtn{
                display: none;
            }

            .header_menu_app{
                display: none;
            }
            .header_menu_pc{
                z-index: 90;
                display: flex;
                align-items: center;
                .menu_item{
                    .active{
                        color: #0BBAB4;
                    }
                    div{
                        font-size: 14px;
                        font-weight: 500;
                        padding: 0 32px;
                        box-sizing: border-box;
                        color: #353856;
                    }
                    div:hover{
                        cursor: pointer;
                    }
                }
                .header_menu_pc_try{
                    margin-left: 16px;
                    border: 1px solid #000;
                    padding: 6px 24px;
                    box-sizing: border-box;
                    border-radius: 32px;
                }
                .header_menu_pc_try:hover{
                    cursor: pointer;
                }
            }

        }
    }
</style>
